import * as React from 'react'
import * as R from 'ramda'
import Card from 'material-ui/Card/Card'
import TextField from 'material-ui/TextField'
import SelectField from 'material-ui/SelectField'
import MenuItem from 'material-ui/MenuItem'
import Table from 'material-ui/Table/Table'
import TableRow from 'material-ui/Table/TableRow'
import TableHeaderColumn from 'material-ui/Table/TableHeaderColumn'
import TableBody from 'material-ui/Table/TableBody'
import TableRowColumn from 'material-ui/Table/TableRowColumn'
import TableHeader from 'material-ui/Table/TableHeader'
import {Step1Data} from '../Step1/Step1State'
import {Step2Data} from '../Step2/Step2State'
import injectSheet from 'react-jss'
import {card} from '../../../Style'

const styles = {
    root: {
        display: 'flex',
        justifyContent: 'center'
    },
    collectedInput: {
        display: 'flex',
        flexDirection: 'row'

    },
    ...card
}

interface Props {
    readonly step1: Step1Data,
    readonly step2: Step2Data,
}

export const Step4View =
    injectSheet<Props>(styles)(
        ({classes, step1, step2}) => (
            <div className={classes.root}>
                <Card
                    className={classes.card}
                    style={{
                        maxWidth: '1536px'
                    }}
                >
                    <div className={classes.cardRow}>
                        <div className={classes.cardColumn}>
                            <h2 className={classes.cardHeader}>Zusammenfassung</h2>
                            <div className="card__content">
                                <TextField
                                    floatingLabelText="Externe Auftragsnummer"
                                    floatingLabelFixed={true}
                                    fullWidth={true}
                                    value={step1.transactionNumber}
                                    disabled={true}
                                />
                                <SelectField
                                    floatingLabelText="Kunde"
                                    floatingLabelFixed={true}
                                    fullWidth={true}
                                    value={step1.customer}
                                    disabled={true}
                                >
                                    <MenuItem
                                        value={step1.customer}
                                        primaryText={step1.customer.longName}
                                    />
                                </SelectField>
                                <SelectField
                                    floatingLabelText="Gesellschaft"
                                    floatingLabelFixed={true}
                                    fullWidth={true}
                                    value={step1.company}
                                    disabled={true}
                                >
                                    <MenuItem
                                        value={step1.company}
                                        primaryText={`${step1.company.name1} ${step1.company.name2}`}
                                    />
                                </SelectField>
                                <SelectField
                                    floatingLabelText="Besteller"
                                    floatingLabelFixed={true}
                                    fullWidth={true}
                                    value={step1.bpsUser}
                                    disabled={true}
                                >
                                    <MenuItem
                                        value={step1.bpsUser}
                                        primaryText={`${step1.bpsUser.lastName}, ${step1.bpsUser.firstName}`}
                                    />
                                </SelectField>
                            </div>
                        </div>
                        <div className={classes.divider}/>
                        <div className={classes.cardColumn}>
                            <h2 className={classes.cardHeader}>Übersicht Produkte</h2>
                            <div className={classes.cardContent}>
                                <Table selectable={false} fixedHeader={false}>
                                    <TableHeader displaySelectAll={false} adjustForCheckbox={false}>
                                        <TableRow>
                                            <TableHeaderColumn>Produkt</TableHeaderColumn>
                                            <TableHeaderColumn>Menge</TableHeaderColumn>
                                        </TableRow>
                                    </TableHeader>
                                    <TableBody displayRowCheckbox={false}>
                                        {R.map(
                                            position =>
                                                <TableRow key={position.product.productId}>
                                                    <TableRowColumn>
                                                        {position.product.name}
                                                    </TableRowColumn>
                                                    <TableRowColumn>
                                                        {position.amount}
                                                    </TableRowColumn>
                                                </TableRow>,
                                            step2.positions)}
                                    </TableBody>
                                </Table>
                            </div>
                        </div>
                    </div>
                </Card>
            </div>)
    )



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Pages/OrderCreate/Step4/Step4.tsx